require('jquery');
require('jquery-ui-sortable-npm');
require('popper.js');
require('./bootstrap');
require('perfect-scrollbar');
require('@coreui/coreui');
require( 'datatables.net-bs4' );
require( 'datatables.net-buttons-bs4' );
require('select2');
require('chart.js');

Cropper = require('cropperjs');

prompt = require("./plugins/jquery-impromptu");
eModal = require("emodal");

require("./imageScripts");

mask = require('jquery-mask-plugin/dist/jquery.mask.min');
moment = require('moment');
moment.locale = require('moment/locale/nl');

$(document).ready(function() {
    $('[data-toggle="tooltip"]').tooltip();

    $(document).on('change', '.custom-file-input', function(){
        $(this).next('.custom-file-label').addClass("selected").html(this.files[0].name);
    });
});